import React, { useRef, useEffect, useMemo } from "react";
import "./style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";
import useIsMobile from '../../hooks/useIsMobile.js'
import { truncateWords } from '../../utils/textUtils'

const SlidOnScrollBanner = ({ sectionsData }) => {
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  const isMobile = useIsMobile()

  const { t } = useTranslation("ksaHome");
  const sectionsButton = t("sectionsButton", { returnObjects: true });
  // Define handleSlideChange function

  const handleSlideChange = (swiper) => {
    const progressBar = document.querySelector(".scroll-bar-progress");
    const scrollBarTexts = document.querySelectorAll(".scroll-bar-text span");

    // Update progress bar width
    const progress = ((swiper.activeIndex + 1) / swiper.slides.length) * 100;
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    }

    // Update active class on scrollbar text
    scrollBarTexts.forEach((text, index) => {
      if (index === swiper.activeIndex) {
        text.classList.add("active");
      } else {
        text.classList.remove("active");
      }
    });
  };

  useEffect(() => {
    const scrollBarTexts = document.querySelectorAll(".scroll-bar-text span");
    if (scrollBarTexts.length > 0) {
      scrollBarTexts[0].classList.add("active");
    }
  }, []);

  // const sectionsButton = useMemo(() => {
  //   return [
  //     { id: 1, heading: "01 Generative AI" },
  //     { id: 2, heading: "02 Blockchain Services" },
  //     { id: 3, heading: "03 Web App Development" },
  //     { id: 4, heading: "04 Mobile App Development" },
  //   ];
  // });

  const goToSlide = (index) => {
    if (sliderRef.current && sliderRef.current.swiper) {
      sliderRef.current.swiper.slideTo(index);
    }
  };

  const handleGtmClick = (bannerName) => {
    // Push data to Google Tag Manager (GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "banner_click",
      banner_name: bannerName,
    });
  };

  return (
    <>
      <div className="mobile-slier container-fluid main-home-banner-box">
        <div className="row">
          <div className="col-md-12 p-0">
            <Swiper
              slidesPerView={1}
              spaceBetween={0}
              onSlideChange={handleSlideChange}
              navigation={false}
              modules={[Navigation, Autoplay]} // Include Autoplay module
              className="mySwiper"
              ref={sliderRef}
              // autoplay={{
              //   delay: 3500, // Delay between slides in milliseconds (3000ms = 3 seconds)
              //   disableOnInteraction: true, // Keep autoplay even after interaction
              //   pauseOnMouseEnter: true,
              // }}
              breakpoints={{
                425: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  loop: true
                },
                375: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  loop: true
                },
                320: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  loop: true
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  loop: false,
                },
                1280: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
              }}
            >

              {/* <section
                    className="mobile-horizontal-section"
                    style={{
                      backgroundImage: `url(${section.backgroundImage})`,
                    }}
                    key={section.id}
                  ></section> */}

              {sectionsData.map((section) => (
                <SwiperSlide>
                  <section
                    className="mobile-horizontal-section"
                    // style={{
                    //   backgroundImage: `url(${section.backgroundImage})`,
                    // }}
                    key={section.id}
                  >
                    <div className="main-banner-box-new banner-bg-image-new h-100">
                      <div className="container h-100">
                        <div className="row flex-convert-box text-center h-100">
                          <div className="col-lg-12 col-md-12">
                            <h3 className="common-text slide-in-top-1 banner-pioner-image banner-payoneer-text">
                              {section.title}{" "}
                              <img
                                src={section.awardLogo}
                                alt={section.awardName}
                              />
                              <span>Payoneer</span>
                            </h3>
                            <h2 className="banner-heading home-banner-heading-text main-banner-heading slide-in-top-2">
                              {section.heading.map((part, index) =>
                                part.isSpan ? (
                                  <span key={index}>{part.text}</span>
                                ) : (
                                  <React.Fragment key={index}>
                                    {part.text}
                                  </React.Fragment>
                                )
                              )}
                            </h2>
                            <div class="row justify-content-center">
                              <div class="col-lg-9">
                                <p className="banner-sub-heading banner-description-text slide-in-top-3 bottom-space-box">
                                  {isMobile ? truncateWords(section.subHeading, 10) : section.subHeading}
                                </p>
                              </div>
                            </div>

                            <div className="services-banner-rating-icon mt-2 mb-4 d-xl-none d-lg-none d-md-none d-sm-none d-col-block">
                              <a href="https://www.youtube.com/watch?v=LDmv2CrkM1c" target='_blank'>
                                <img src="/images/new-Payoneer.svg" width={140} alt="Best Web Development Company Awarded by Payoneer" />
                              </a>
                              <a href="https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights" target='_blank'>
                                <img src="/images/new-clutch.svg" width={100} alt="Bitsclan IT Solutions Trusted by Clutch" />
                              </a>
                            </div>

                            {/* .slide-in-top-4 */}
                            <div className="w-full d-flex justify-content-center mt-3">
                              <Button
                                styles={{
                                  paddingLeft: "30px",
                                  paddingRight: "30px",
                                }}
                                text={section.buttonText}
                                link={section.buttonLink}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        <div className="both-bars container">
          <div className="scroll-bar-container">
            <div className="scroll-bar-progress"></div>
          </div>
          <div className="scroll-bar-text">
            {sectionsButton.map((section, index) => (
              <span
                className="home-banner-slider-banner-btn"
                key={section.id}
                onClick={() => {
                  goToSlide(index);
                  handleGtmClick(section.heading);
                }}
              >
                {`${section.heading || ""}`}
              </span>
            ))}
          </div>
        </div>

        {/* <div className="row">
          <div className="col-md-12 remove-small-screes">
            <img src="/images/life-at-bitsclan/mouse.svg" alt="CEO Image" style={{ position: 'absolute', top: '7rem', insetInlineEnd: '2rem', zIndex: '9', width: '30%', }} />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default SlidOnScrollBanner;
